"use client"

import { type PropsWithChildren } from "react"
import { ContentfulLivePreviewProvider } from "@contentful/live-preview/react"

interface Props {
    enabled?: boolean
}

export function ContentfulPreviewProvider({ children, enabled }: PropsWithChildren<Props>) {
    if (!enabled) {
        return <>{children}</>
    }

    const debugMode = process.env.NODE_ENV !== "production"

    return (
        <ContentfulLivePreviewProvider
            locale="en-US"
            enableInspectorMode
            enableLiveUpdates
            debugMode={debugMode}
        >
            {children}
        </ContentfulLivePreviewProvider>
    )
}
